<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      size="xl"
      :title="mainTitle"
    >
      <slot name="body">
          
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="4">
              <form-mask
                label="سنة المجلس"
                id="ID_number"
                v-model="form.board_year"
                options="blockNomber4"
                rules="required|max:4"
              />
              <small class="text-danger" v-if="!isTrue">لا يمكنك إنشاء مجلس لهذه السنة و ذلك لوجود مجلس أخر موجودة ضمنه</small>
              <small class="text-danger" v-if="form.board_year && form.board_year.length<4"> يجب أن نكون سنة المجلس بطول 4 </small>
            </b-col>
            <b-col  cols="12 mt-2">
              معلومات الأعضاء :
              <hr />
            </b-col>
            <b-col cols="12"   v-for="(member, memberId) in form.directors" :key="memberId">
              <b-row>
                <b-col cols="12">
                  <h5 class="mb-2">
                    العضو {{ getArrangement(memberId+1) }}

                  </h5>
                  
                </b-col>
                <b-col cols="12">
                </b-col>
                
                <b-col cols="2">
                  
                  <form-input
                    :label= "` ${memberId+1} -الاسم الكامل  `"
                    v-model="member.name"
                    rules="required"
                    id="name"
                  />
                </b-col>
                <b-col cols="2">
                  <form-select
                    id="qualifications"
                    rules="required"
                    :label= "` ${memberId+1} - المؤهل العلمي  `"
                    v-model="member.qualification_id"
                    :reduce="(x) => x"
                    :getOptionLabel="(x) => x.title"
                    ep="v2/selects/qualifications"
                    
                  />
                </b-col>
                <b-col cols="2">
                  <form-select
                    id="job-titles"
                    rules="required"
                    :label="`${memberId+1} - الصفة `"
                    v-model="member.job_title_id"
                    :reduce="(x) => x"
                    :getOptionLabel="(x) => x.name"
                    ep="v2/selects/job-titles"
                    
                  />
                </b-col>
                <b-col ols="2">
                  <form-mask
                    :label="`${memberId+1} - رقم الموبايل `"
                    id="phone_number"
                    v-model="member.phone_number"
                    options="blockNomber10"
                    rules="required"
                  />
                </b-col>
                
                <b-col cols="2">
                  <form-mask
                    :label="`${memberId+1} - تاريخ الميلاد `"
                    id="dob"
                    v-model="member.dob"
                    :raw="false"
                    placeholder="YYYY-MM-DD"
                    options="date"
                    rules="required"
                  />
                </b-col>
                
                <b-col cols="2">
                  
                  <form-mask
                    :label="`${memberId+1} -  الرقم الوطني `"
                    id="ID_number"
                    v-model="member.ID_number"
                    options="blockNomber11"
                    rules="required"
                  />
                </b-col>
                <b-col cols="2">
                  <form-file-input
                    placeholder="اختر ملفاً"
                    id="document"
                    :label="`${memberId+1} - نشرة الإستعلام `"
                    accept=".pdf"
                    v-model="member.inquiry_bulletin_file"
                    rules="required"
                  />
                </b-col>
                <b-col cols="12" v-if="memberId !== form.directors.length-1">
                  <hr />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <small class="text-danger d-flex align-items-end justify-content-end" v-if="duplicateString.length >0"> يجب أن يكون هناك عضو واحد يحمل صفة {{ duplicateString[0] }}</small>
              
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer , max } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
import axios from "@axios";
// import store from "../pages/transactions/store";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["TransactionType"]),
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactionType"]),
  },
  data() {
    return {
      form: {},
      required,
      integer,
      isTrue : true,
      duplicateString : 0,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    }, 
    form: {
      handler: async function(newVal, oldVal) {
        if(newVal.board_year && newVal.board_year.length === 4){
          await axios.post(`v2/check-director-board-end-year`, {
            board_year: newVal.board_year
          })
          .then((res) => this.isTrue = res.data.data);
        }
        else{
          this.isTrue = true
        }
      },
      deep: true
    }
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      let slugMap = [];
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.form.board_end_year = parseFloat(this.form.board_year) + parseFloat(this.form.term_of_office)
          
          this.form.directors.forEach(obj => {
            let slug = obj.job_title_id.slug;
            slugMap.push(slug)
          });
          console.log('slug' , slugMap)
          const array = ['أمين صندوق' , 'أمين سر' , 'نائب رئيس مجلس' , 'رئيس مجلس'];
          this.duplicateString = slugMap.filter((item, index) => slugMap.indexOf(item) !== index && (array.some(e => e === item)));
          if(this.isTrue === true && this.form.board_year.length === 4 && this.duplicateString.length ===0){
            this.$emit("confirm", this.form);
          }

        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    }
  },
};
</script>
